import { Button, TextField } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer/Drawer';
import Grid from '@material-ui/core/Grid/Grid';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import { ITheme } from 'interfaces/theme';
import React, { Component } from 'react';
import rxjsOperators from 'rxjs-operators';
import authService from 'services/auth';
import { campaignService } from 'services/campaignService';
import { productNewService } from 'services/productNewService';
import { themeService } from 'services/themeService';
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import PlusIcon from 'mdi-react/PlusIcon';

import ThemeItem from './ThemeItem';
import ActionsTheme from './ActionsTheme';
import CreateTheme from './CreateTheme';
import { NoThemesState } from './NoThemesState';
import { NoSearchState } from './NoSearchState';
import { analyticsG4, enFeatures } from 'services/AnalyticsG4';
import { combineLatest } from 'rxjs';

interface IState {
  selectedTheme?: ITheme;
  themes?: Array<ITheme>;
  selectedProduct: IProductNew;
  filterThemes: string;
  isCreating: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  drawerContainer: {
    width: '100%',
    backgroundColor: '#ECEFF1',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    overflowY: 'visible'
  },
  containerMyThemes: {
    overflow: 'auto',
    width: '100%',
    fontFamily: 'Open Sans',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555'
    }
  },
  drawerTitle: {
    margin: '20px 0',
    fontSize: '1.5rem',
    color: '#fff'
  },
  newThemeBtn: {
    backgroundColor: theme.variables.colors['primaryColor'],
    color: '#FFF',
    padding: '11px 16px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.variables.colors['buttonBackgroundHover']
    }
  },
  newTheme: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#959595',
    justifyContent: 'center',
    backgroundColor: '#fff'
  },
  filterTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#FFF',
    height: 100,
    padding: '0 40px'
  },
  noResult: {
    width: '100%',
    textAlign: 'center',
    color: '#37474F',
    fontStyle: 'italic'
  },
  themeContent: {
    height: 'calc(100% - 135px)',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  createThemeItem: {
    width: '33.3%',
    minHeight: 130,
    padding: '10px 15px 0 15px',
    minWidth: 300,
    display: 'flex',
    justifyContent: 'center',
    '@media screen and (min-width: 1480px)': {
      width: '25%'
    }
  },
  listThemes: {
    padding: '30px 0',
    margin: 0,
    overflow: 'unset',
    height: '100%'
  },
  inputSearch: {
    fontFamily: 'Open Sans',
    fontSize: '1rem'
  },
  search: {
    marginRight: 8,
    '& svg': {
      width: 20,
      height: 30,
      marginRight: 10
    }
  },
  cancelButton: {
    padding: '12px 16px 8px 10px',
    border: 'none',
    color: theme.variables.colors['primaryColor']
  }
}))
export default class MyThemes extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      themes: [],
      selectedTheme: null,
      selectedProduct: null,
      filterThemes: '',
      isCreating: false
    };
  }

  componentDidMount() {
    themeService
      .getThemes()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(themes => this.setState({ themes }));

    themeService
      .getSelectedTheme()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(selectedTheme => {
        this.setState({ selectedTheme });
      });

    productNewService
      .getSelectedProduct()
      .pipe(
        rxjsOperators.tap(selectedProduct => this.setState({ selectedProduct })),
        rxjsOperators.filter(selectedProduct => !!selectedProduct),
        rxjsOperators.combineLatest(authService.getUser()),
        rxjsOperators.switchMap(([selectedProduct, user]) => {
          return campaignService.loadCampaign(selectedProduct.id, user.id);
        }),
        rxjsOperators.bindComponent(this)
      )
      .subscribe(() => {});

    themeService
      .getFilterThemes()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(filterThemes => this.setState({ filterThemes }));

    combineLatest([themeService.getThemes(), productNewService.getSelectedProduct()])
      .pipe(
        rxjsOperators.filter(([themes, selectedProduct]) => !!themes && !!selectedProduct),
        rxjsOperators.map(([, selectedProduct]) => {
          return { ...selectedProduct, theme: null };
        }),
        rxjsOperators.distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      )
      .subscribe(() => analyticsG4.sendPageView({ feature: enFeatures.TEMA }));
  }

  selectTheme = (theme: ITheme): any => {
    themeService.setSelectedTheme(theme);
  };

  onClose = () => {
    themeService.clearThemes();
    themeService.setIsCreating(false);
    themeService.setSelectedTheme(null);

    this.setState({ themes: null });
  };

  creatingTheme = () => {
    themeService.setIsCreating(true);
    themeService.setSelectedTheme(null);
  };

  filterThemes = (event: any) => {
    themeService.setFilterThemes(event.target.value);
  };

  render() {
    const { classes } = this.props;
    const { selectedProduct, selectedTheme, themes, filterThemes } = this.state;

    if (!themes || !selectedProduct) {
      return null;
    }

    return (
      <Drawer
        anchor="right"
        open={!!themes}
        ModalProps={{ classes: { root: classes.removeBackdrop }, disableBackdropClick: true }}
        PaperProps={{ classes: { root: classes.drawerContainer } }}
        transitionDuration={{ enter: 500, exit: 500 }}
      >
        <div className={`${classes.containerMyThemes}`}>
          <div className={classes.filterTitle}>
            <Button className={classes.cancelButton} variant="outlined" onClick={this.onClose}>
              <ChevronLeftIcon />
              Voltar
            </Button>
            <Grid>
              <TextField
                placeholder="Pesquisar por tema"
                onChange={this.filterThemes}
                value={filterThemes}
                className={classes.search}
                InputProps={{
                  className: classes.inputSearch,
                  endAdornment: <SvgIcon name="search" />
                }}
              />
              <Button className={classes.newThemeBtn} variant="contained" onClick={this.creatingTheme}>
                <PlusIcon />
                Criar novo tema
              </Button>
            </Grid>
          </div>

          <div className={classes.themeContent}>
            <Grid className={classes.listThemes} container alignItems="flex-start" spacing={24}>
              {themes.length >= 1 ? (
                themes.filter(theme => theme.name.toLowerCase().includes(filterThemes.toLocaleLowerCase())).length >
                0 ? (
                  themes
                    .filter(theme => theme.name.toLowerCase().includes(filterThemes.toLocaleLowerCase()))
                    .filter(theme =>
                      selectedProduct.type === 4
                        ? theme.config.template !== '14' && theme.config.template !== '16'
                        : true
                    )
                    .map((theme: ITheme) => (
                      <ThemeItem
                        key={theme.id}
                        classes={classes}
                        theme={theme}
                        selectedTheme={selectedTheme}
                        selectedProduct={selectedProduct}
                        onSelect={this.selectTheme}
                      />
                    ))
                ) : (
                  <NoSearchState />
                )
              ) : (
                <NoThemesState />
              )}
            </Grid>
          </div>
        </div>
        <ActionsTheme />
        <CreateTheme />
      </Drawer>
    );
  }
}
